// NATIVE 
import { useState } from 'react';


// INSTALLED 
import Backdrop from '@mui/material/Backdrop';
import { ThemeProvider } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';


// CUSTOM 
import { theme } from '../commons/theme';



/**
 * Preload component that displays a backdrop with a circular progress indicator.
 * 
 * This component uses a `ThemeProvider` to apply a theme and a `Backdrop` to display
 * a loading indicator. The backdrop is controlled by a state variable `isopen` which
 * determines whether the backdrop is visible or not. Clicking on the backdrop will
 * trigger the `handleClose` function, which currently sets `isopen` to `true`.
 * 
 * @component
 * @example
 * return (
 *   <Preload />
 * )
 */
export const Preload = () => {


    // USE STATE 
    const [isopen, setIsOpen] = useState(true);


    // CONST FUNCTIONS 
    const handleClose = () => {
      setIsOpen(true);
    };
    

    return (
        <ThemeProvider theme={theme}>
            <Backdrop
                sx={{ color: 'primary', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isopen}
                onClick={handleClose}
                >
                <CircularProgress color='secondary'/>
            </Backdrop>
            
        </ThemeProvider>
        
    )
}